import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export class TexteingabeInput {
    text: string;
}

export class TexteingabeResult {
    constructor(
        public text: string,
        public confirmed: boolean,
    ) {}
}

@Component({
    selector: 'kiene-texteingabe-dialog',
    templateUrl: './texteingabe-dialog.component.html',
    styleUrls: ['./texteingabe-dialog.component.scss'],
})
export class TexteingabeDialogComponent implements OnInit {
    texte: string[] = [];
    public textCtrl = new UntypedFormControl();

    constructor(
        public dialogRef: MatDialogRef<TexteingabeDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: TexteingabeInput,
    ) {}

    ngOnInit(): void {
        this.textCtrl.setValue('');
    }

    save() {
        const result = new TexteingabeResult(this.textCtrl.value, true);
        this.dialogRef.close(result);
    }
}
